import history from '../history.js'

function setLoggedOut () {
  window.localStorage.removeItem('token')
  window.localStorage.removeItem('businessPartnerId')
  history.push('/login#')
}

export default setLoggedOut
